export default function toDate($filter) {
    return function (dateString, format) {
        if (! dateString || dateString === '-0001-11-30 00:00:00' || dateString.toString() == 'Invalid Date') {
            return '-';
        }
        var dateObject = new Date(dateString.replace(/-/g, '/'));

        if (format == 'spoken') {
            format = 'yyyy MM dd';
            var toDay = new Date();
            var yesterDay = new Date();
            var tomorrow = new Date();
            yesterDay.setDate(yesterDay.getDate() - 1);
            tomorrow.setDate(tomorrow.getDate() + 1);

            var toDate = $filter('date')(dateObject, format);

            toDay = $filter('date')(toDay, format);
            yesterDay = $filter('date')(yesterDay, format);
            tomorrow = $filter('date')(tomorrow, format);

            if (toDate == toDay || toDate == yesterDay || toDate == tomorrow) {
                if (toDate == tomorrow) {
                    return 'DATE:TOMORROW';
                }

                return toDate == toDay ? "DATE:TODAY" : "DATE:YESTERDAY";
            }
        }

        if (format == 'short') {
            format = 'yyyy-MM-dd hh:mm'
        }

        return $filter('date')(dateObject, format)
    }
};